




























































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Mutation, State, Getter, Action } from 'vuex-class';
import { client } from '../../store';
import { IProposal, IPageParams, ITableOptions, IUser } from '../../models';
import { Watch } from 'vue-property-decorator';
import { getUserFullName } from '@/helpers/functions';
import { DateTime } from 'luxon';
import paginationMixin from '@/mixins/pagintation';
@Component({
  components: {
    UIActions: () => import('@/components/UI/Actions.vue'),
  },
  data: () => ({
    DateTime,
    namespace: 'proposal',
  }),
  methods: {
    getUserFullName,
  },
  mixins: [paginationMixin],
})
export default class ProposalList extends Vue {
  @State('currentUser', { namespace: 'user' })
  currentUser: IUser;
  @Action('deleteEntities', { namespace: 'proposal' })
  deleteEntities: () => void;
  @Action('getEntities', { namespace: 'proposal' }) getEntities: () => void;
  @Action('updateEntity', { namespace: 'proposal' }) updateEntity: any;
  @Getter('entitiesSlice', { namespace: 'proposal' })
  entitiesSlice: IProposal[];
  @State('pageParams', { namespace: 'proposal' }) pageParams: IPageParams;
  @State('loading', { namespace: 'proposal' }) loading: boolean;
  selected = [];
  interval = null;
  expanded = [];
  headers = [
    { text: '#', value: 'id' },
    { text: 'Файлы', value: 'files', sortable: false },
    { text: 'Название', value: 'name' },
    { text: 'Контрагент', value: 'contractor.name', sortable: false },
    { text: 'Ответственный', value: 'responsible', sortable: false },
    { text: 'Дата создания', value: 'created_at' },
    { text: 'Создатель', value: 'creator', sortable: false },
    { text: 'Статус', value: 'proposal_status', sortable: false },
    {
      text: 'Представители',
      value: 'representatives',
      sortable: false,
    },
  ];
  filters = [
    {
      searchKey: 'id',
      label: 'Номер',
      component: 'v-text-field',
      itemText: 'name',
    },
    {
      searchKey: 'name',
      label: 'Название',
      component: 'v-text-field',
      itemText: 'name',
    },
    {
      searchKey: 'description',
      label: 'Описание',
      component: 'v-text-field',
      itemText: 'description',
    },
    {
      searchKey: 'contractor_id',
      label: 'Контрагент',
      url: '/contractor/all',
      immediately: true,
      multiple: true,
      component: 'v-autocomplete',
      itemText: 'name',
    },
    {
      searchKey: 'responsible_id',
      label: 'Ответственный',
      url: '/user/all',
      immediately: true,
      multiple: true,
      component: 'v-autocomplete',
      itemText: (item: IUser) => getUserFullName(item),
    },
    {
      searchKey: 'creator_id',
      label: 'Создатель',
      immediately: true,
      multiple: true,
      component: 'v-autocomplete',
      url: '/user/all',
      itemText: (item: IUser) => getUserFullName(item),
    },
    {
      searchKey: 'proposal_status_id',
      label: 'Статус',
      immediately: true,
      multiple: true,
      component: 'v-autocomplete',
      url: '/proposal_status/all',
      itemText: 'name',
    },
  ];
  modalPatch = {};
  getReadStatus(item: IProposal) {
    if (this.currentUser && this.currentUser.id === item.responsible_id) {
      return !item.read;
    } else return false;
  }
  setModalPatchField(field: string, value: any) {
    Vue.set(this.modalPatch, field, value);
  }
  updateModalEntity() {
    this.updateEntity(this.modalPatch);
  }
}
